<template>
  <div v-if="certificatemasterid||certificaruleid">
    <Vip
      :certificatemasterid="certificatemasterid"
      :certificaruleid="certificaruleid"
    ></Vip>
  </div>
</template>

<script>
import Vip from "./vip.vue";
export default {
  name:'svipDetail',
  data() {
    return {
      certificatemasterid: "",
      certificaruleid: "",
    };
  },
  components: {
    Vip,
  },
  methods: {},
  mounted() {
    this.certificatemasterid = this.$route.query.certificatemasterid
      ? this.$route.query.certificatemasterid
      : "";
    this.certificaruleid = this.$route.query.certificaruleid? this.$route.query.certificaruleid: "";
  },
};
</script>

<style lang="scss" scoped>
</style>